import { render, staticRenderFns } from "./controls.vue?vue&type=template&id=36a9e3d5&scoped=true&"
import script from "./controls.vue?vue&type=script&lang=js&"
export * from "./controls.vue?vue&type=script&lang=js&"
import style0 from "./controls.vue?vue&type=style&index=0&id=36a9e3d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a9e3d5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36a9e3d5')) {
      api.createRecord('36a9e3d5', component.options)
    } else {
      api.reload('36a9e3d5', component.options)
    }
    module.hot.accept("./controls.vue?vue&type=template&id=36a9e3d5&scoped=true&", function () {
      api.rerender('36a9e3d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tracking/partials/controls.vue"
export default component.exports